export const RECIPIENT_FILTER_ATTRIBUTES = [
    {
        "label": "Country",
        "value": "DagNm",
        "DataType": "Array<String>",
        "DefaultValue": ["US"]
    },
    {
        "label": "Division",
        "value": "SubdivName",
        "DataType": "Array<String>",
    },
    {
        "label": "Associate Type",
        "value": "PayTypeCodeDesc",
        "DataType": "Array<String>",
    },
    {
        "label": "Parent Business (Segment)",
        "value": "EntityParent",
        "DataType": "Array<String>",
    },
    {
        "label": "Store City",
        "value": "StoreCityName",
        "DataType": "Array<String>",
    },
    {
        "label": "State/Province Code",
        "value": "StateProvCode",
        "DataType": "Array<String>",
    },
    {
        "label": "Store Associate - boolean",
        "value": "StoreAscInd",
        "DataType": "boolean",
    },
    {
        "label": "Job family",
        "value": "JobFamily",
        "DataType": "Array<String>",
    },
    {
        "label": "Job Family Group",
        "value": "WdJobFamilyGrpId",
        "DataType": "Array<String>",
    },
    {
        "label": "Campus hub",
        "value": "WorkLocType",
        "DataType": "Array<String>",
    },
    {
        "label": "Pad area",
        "value": "PadArea",
        "DataType": "Array<String>",
    },
    {
        "label": "Store type",
        "value": "StoreTypeDesc",
        "DataType": "Array<String>",
    },
    {
        "label": "Store number",
        "value": "StoreNbr",
        "DataType": "Array<String>",
    },
    {
        "label": "Fin Org Type Group",
        "value": "FinOrgType",
        "DataType": "Array<String>",
    },
    {
        "label": "Region",
        "value": "RegnNm",
        "DataType": "Array<String>",
    },
    {
        "label": "Market",
        "value": "MktAreaNm",
        "DataType": "Array<String>",
    },
    {
        "label": "Business Unit",
        "value": "BUDesc",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 2 Name",
        "value": "Level2Name",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 3 Name",
        "value": "Level3Name",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 4 Name",
        "value": "Level4Name",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 5 Name",
        "value": "Level5Name",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 6 Name",
        "value": "Level6Name",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 7 Name",
        "value": "Level7Name",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 8 Name",
        "value": "Level8Name",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 9 Name",
        "value": "Level9Name",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 10 Name",
        "value": "Level10Name",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 11 Name",
        "value": "Level11Name",
        "DataType": "Array<String>",
    },
    {
        "label": "Level 12 Name",
        "value": "Level12Name",
        "DataType": "Array<String>",
    }
];

export const RECIPIENT_FILTER_OPERATORS = [
    {
        "label": "AND",
        "value": "AND"
    },
    {
        "label": "OR", 
        "value": "OR"
    }
];